import { useEffect } from 'react';
import '../styles/fx_cursorBubbles.css';

function CursorBubbles() {
  useEffect(() => {
    const THROTTLE_MS = 100;
    const LONG_PRESS_MS = 400; // delay before long press starts emitting

    function spawnBubble(x, y) {
      const size = 6 + Math.random() * 14;
      const drift = -12 + Math.random() * 24;
      const duration = 0.6 + Math.random() * 0.7;

      const bubble = document.createElement('div');
      bubble.className = 'cursorBubble';
      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      bubble.style.left = `${x - size / 2}px`;
      bubble.style.top = `${y - size / 2}px`;
      bubble.style.setProperty('--bubble-duration', `${duration}s`);
      bubble.style.setProperty('--drift', `${drift}px`);

      document.body.appendChild(bubble);
      bubble.addEventListener('animationend', () => bubble.remove(), { once: true });
    }

    // --- Mouse (desktop) ---
    const isTouch = window.matchMedia('(hover: none)').matches;

    let lastTime = 0;
    const handleMouseMove = (e) => {
      if (isTouch) return;
      const now = Date.now();
      if (now - lastTime < THROTTLE_MS) return;
      lastTime = now;
      spawnBubble(e.clientX, e.clientY);
    };

    // --- Touch long press (mobile) ---
    let touchX = 0;
    let touchY = 0;
    let longPressTimer = null;
    let burstInterval = null;

    const startBurst = () => {
      spawnBubble(touchX, touchY); // immediate first bubble
      burstInterval = setInterval(() => spawnBubble(touchX, touchY), THROTTLE_MS);
    };

    const stopBurst = () => {
      clearTimeout(longPressTimer);
      clearInterval(burstInterval);
      longPressTimer = null;
      burstInterval = null;
    };

    const handleTouchStart = (e) => {
      const touch = e.touches[0];
      touchX = touch.clientX;
      touchY = touch.clientY;
      longPressTimer = setTimeout(startBurst, LONG_PRESS_MS);
    };

    const handleTouchMove = (e) => {
      const touch = e.touches[0];
      touchX = touch.clientX;
      touchY = touch.clientY;
      // If finger moves a lot before long press fires, cancel
      clearTimeout(longPressTimer);
      if (longPressTimer && !burstInterval) longPressTimer = null;
    };

    const handleTouchEnd = () => stopBurst();
    const handleTouchCancel = () => stopBurst();

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd);
    document.addEventListener('touchcancel', handleTouchCancel);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
      document.removeEventListener('touchcancel', handleTouchCancel);
      stopBurst();
    };
  }, []);

  return null;
}

export default CursorBubbles;
